import { DashboardDialogSelectOption } from './DashboardDialogSelectOption';
import { Asset } from '../../../assets/dto/Asset';

export class DashboardDialogAssetOption extends DashboardDialogSelectOption {
  constructor(public asset: Asset) {
    super(asset.guid, asset.takenBy ? `${asset.guid} (${asset.takenBy})` : asset.guid);
  }
}
